import type { PermissionType } from "@/shared/constants/permissions";

/**
 * User role values
 */
export const UserRole = {
  ADMIN: "admin",
  USER: "user",
  MODERATOR: "moderator",
  GUEST: "guest",
} as const;

/**
 * User role type
 */
export type UserRoleType = typeof UserRole[keyof typeof UserRole];

/**
 * User permissions type
 * Uses centralized PermissionType from @/shared/constants
 */
export type UserPermission = PermissionType;

/**
 * User interface
 */
export interface User {
  id: string
  email: string
  name: string
  nickname?: string
  avatar?: string
  role: UserRoleType
  permissions: UserPermission[]
  createdAt: string
  updatedAt: string
}

/**
 * Auth state interface
 */
export interface AuthState {
  user: User | null
  isLoading: boolean
  isInitialized: boolean
  error: string | null
}

export interface PasswordChangePayload {
  email?: string
  password: string // old password
  newPassword: string
  newPasswordConfirmation: string
}

export interface ResetPasswordPayload {
  newPassword: string
  newPasswordConfirmation: string
}
